import { Component, OnInit, Input, OnDestroy, ViewChild } from "@angular/core";
import { BaseComponent } from "../../Library/BaseComponent";
import {
    ComplainRegister,
    ComplainSearch,
    Filter_Update_Request,
    Glitch_SearchRequest,
} from "../../Models/RequestModels";
import { MasterDataService } from "../../Services/MasterDataService";
import { ActivatedRoute, Router } from "@angular/router";
import {
    CallStatuses,
    EntityCodes,
    ComplainSearch_GroupBy,
    AuthActionCodes,
    ModuleLicenceCodes,
    GlitchSearch_GroupBy,
    FilterTypes,
    GlitchStatuses,
} from "../../Models/EnumModels";
import { PMSService } from "../../Services/PMSService";
import { GuestLookup, ListResponse } from "../../Models/ResponseModels";
import * as _ from "lodash";
import { ComplainService } from "../../Services/ComplainService";
import {
    TopFilterStatModel,
    SearchTextResult,
} from "../../Models/CommonModels";
import * as alasql from "alasql";
import {
    GenericMaster,
    GenericMaster_String,
    LocationLookup,
    CallDescriptionLookup,
    CallCategoryLookup,
    VIP,
    PropertyBasicInfo,
    GlitchDescription,
    GlitchCategory,
} from "../../Models/GlobalEntities";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { UserService } from "../../Services/UserService";
import { GlitchService } from "../../Services/GlitchService";
import { GlitchSearchResult } from "../GlitchSearchResult/GlitchSearchResult";

@Component({
    selector: "GlitchConsole_Compact",
    templateUrl: "./GlitchConsole_Compact.html",
})
export class GlitchConsole_Compact
    extends BaseComponent
    implements OnInit, OnDestroy
{
    @ViewChild("glitchSearchResult") glitchSearchResult: GlitchSearchResult;

    RequestModel: Glitch_SearchRequest;
    Model: ListResponse;
    _LocationId: number;
    DateFormat: string;
    PropStatModel: Array<TopFilterStatModel<number>> = [];
    Timer: any;
    cDate: Date = new Date();
    SortParams: Array<GenericMaster_String> = [];
    SearchOnEntities: Array<EntityCodes> = [
        EntityCodes.GlitchDescriptionMaster,
        EntityCodes.GlitchCategories,
        EntityCodes.Dept,
        EntityCodes.Location,
        EntityCodes.Sections,
        EntityCodes.Staff,
    ];

    lstLocations: Array<LocationLookup> = [];
    lstStaff: Array<GenericMaster> = [];
    lstGlitchDescription: Array<GlitchDescription> = [];
    lstGlitchCategories: Array<GlitchCategory> = [];
    lstDepartments: Array<GenericMaster> = [];
    lstSections: Array<GenericMaster> = [];
    lstProperties: Array<PropertyBasicInfo> = [];
    KeywordSearch: string = null;
    IsSubmitting: boolean = false;

    MasterCache: any = {};

    _GlitchSearch_GroupBy = GlitchSearch_GroupBy;
    GroupTypes: Array<GenericMaster> = [];

    SelectedProperties: Array<number> = [];

    EnabledFilters: Array<FilterTypes> = [
        FilterTypes.GlitchDescription,
        FilterTypes.GlitchCategory,
        FilterTypes.Location,
        FilterTypes.Dept,
        FilterTypes.GlitchStaff,
        FilterTypes.RegisteredBy,
        FilterTypes.HasInvestigation,
        FilterTypes.HasRecovery,
        FilterTypes.Vip,
    ];

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected pmsService: PMSService,
        public complainService: ComplainService,
        public userService: UserService,
        public glitchService: GlitchService
    ) {
        super(translate, toastr, route, router, masterService);

        this.DateFormat = this.masterService.GetPropertyDateFormat(null);

        this.lstProperties = this.masterService.GetProperties_Action(
            AuthActionCodes.GlitchView
        );

        this.InitRequestModel();

        this.PopulateTopFilters();
    }

    ngOnDestroy(): void {
        window.clearInterval(this.Timer);
    }

    ngOnInit(): void {
        //this.SetTopStatusData();
        //this.onLoadFilter();
        //this.SetData();
        //this.CreateCache();
    }

    InitRequestModel(): void {
        this.RequestModel = new Glitch_SearchRequest();
        this.RequestModel.SetDefaults();

        this.RequestModel.IgnoreCloseDays = true;

        this.SetSearchProperties();
    }

    SetSearchProperties(): void {
        if (
            this.SelectedProperties == null ||
            (this.SelectedProperties.length == 0 &&
                this.lstProperties.length > 0)
        ) {
            let propId = this.masterService.GetDefaultProperty_Action(
                AuthActionCodes.GlitchView
            );

            if (propId != null) this.SelectedProperties.push(propId);
        }

        this.RequestModel.Properties = _.cloneDeep(this.SelectedProperties);

        //for (let i = 0; i < this.masterService.LoggedInUserData.Properties.length; i++) {
        //    this.RequestModel.Properties.push(this.masterService.LoggedInUserData.Properties[i].PropertyId);
        //}
    }

    PopulateTopFilters(): void {
        this.PropStatModel.push({
            Id: null,
            IconClass: "fa fa-bars",
            Label: "SHORT_NAME.SHORT_NAME_ALL",
            Value: 0,
        });

        this.PropStatModel.push({
            Id: 1,
            IconClass: "fa fa-unlock-alt",
            Label: "SHORT_NAME.SHORT_NAME_OPN",
            Value: 0,
        });

        this.PropStatModel.push({
            Id: 0,
            IconClass: "fa fa-lock",
            Label: "SHORT_NAME.SHORT_NAME_CLS",
            Value: 0,
        });
    }

    FindStatus(Status: number): TopFilterStatModel<number> {
        return this.PropStatModel.find((value) => {
            return value.Id == Status;
        });
    }

    Transform_TopFilter(lst: any): void {
        let totalCount = 0;

        if (lst == null) {
            //console.info("A = " + this.PropStatModel.length);
            for (let i = 0; i < this.PropStatModel.length; i++) {
                let row = this.PropStatModel[i];

                if (row != null && row.Id != null) {
                    totalCount = totalCount + row.Value;
                }
            }
        } else {
            for (let i = 0; i < this.PropStatModel.length; i++) {
                let row = this.PropStatModel[i];

                if (row != null && row.Id != null) {
                    // converting number to string, because StatusCode in response is a string and number in request
                    const rowStr = "" + row.Id;
                    let count = alasql(
                        "Select SUM([Count]) as cnt from ? where StatusCode = ?",
                        [lst, rowStr]
                    );

                    row.Value = count[0].cnt;
                    totalCount = totalCount + row.Value;
                }
            }
        }

        this.FindStatus(null).Value = totalCount;
    }

    SetTopStatusData(): void {
        this.IsSubmitting = true;
        this.glitchService
            .Glitch_Search_Counts(this.RequestModel)
            .then((data) => {
                this.Transform_TopFilter(data);
                this.IsSubmitting = false;
            });
    }

    onTopFilter(StatusCode: any): void {
        this.RequestModel.Status = StatusCode;
        this.SetTopStatusData();
        this.SetData();
    }
    isPropSelected(id: number): boolean {
        if (this.RequestModel == null || this.RequestModel.Properties == null)
            return false;

        return this.RequestModel.Properties.findIndex((a) => a == id) >= 0;
    }
    SetData(): void {
        let pCode = this.RequestModel.Status;
        this.glitchService.SelectedGlitch = null;

        if (this.RequestModel.GroupBy == GlitchSearch_GroupBy.None) {
            this.glitchSearchResult.RequestModel = this.RequestModel;
            this.glitchSearchResult.Show();
            return;
        }

        this.glitchService.SelectedGlitch = null;
        this.IsSubmitting = true;

        this.Model = new ListResponse();
        this.Model.Result = [];

        this.glitchService
            .Glitch_Search(this.RequestModel)
            .then((data) => {
                //console.info(data);

                this.Model = data;
                this.RequestModel.PageNumber = data.CurrentPage;
                this.IsSubmitting = false;
            })
            .catch((reason) => {
                this.IsSubmitting = false;
            });
    }

    onFilter(row: GenericMaster_String): void {
        this.RequestModel.OrderBy = row.Id;
        this.SetData();
    }

    onSelected(Model: any): void {
        this.glitchService.SelectedGlitch = Model;
    }

    RefreshData(): void {
        this.SetTopStatusData();
        this.SetData();
    }

    Open(req: Glitch_SearchRequest): void {
        this.Transform_TopFilter(null);

        if (
            req == null ||
            req.Properties == null ||
            req.Properties.length == 0
        ) {
            this.RequestModel = null;
            this.Model = null;
            this.glitchSearchResult.RequestModel = null;
            this.glitchSearchResult.Show();

            return;
        }

        this.RequestModel = _.cloneDeep(req);
        this.RequestModel.Status = GlitchStatuses.Open;
        this.RequestModel.IgnoreCloseDays = true;
        this.glitchSearchResult.RequestModel = this.RequestModel;

        this.RefreshData();

        this.glitchSearchResult.Show();
    }
}
